var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isLoading && (_vm.isFeatureFlagEnabled || _vm.allowDisabled)
    ? _c(
        "div",
        {
          staticClass: "feature-flag",
          class:
            ((_obj = {}),
            (_obj[_vm.display] = _vm.display),
            (_obj.enabled = _vm.isFeatureFlagEnabled),
            (_obj.disabled = !_vm.isFeatureFlagEnabled),
            _obj),
          style: {
            flexGrow: _vm.grow,
            marginRight: _vm.margin,
            maxWidth: _vm.width
          }
        },
        [
          _vm.isFeatureFlagEnabled ? _vm._t("default") : _vm._e(),
          _vm._v(" "),
          _vm.isFeatureFlagEnabled ? _vm._t("enabled") : _vm._e(),
          _vm._v(" "),
          !_vm.isFeatureFlagEnabled ? _vm._t("disabled") : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67c795f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67c795f4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/feature-flag.vue
// module id = 1327
// module chunks = 0